import {
  AudioWaveform,
  LayoutDashboard,
  FolderOpen,
  Package,
  Settings,
  ReceiptText,
} from "lucide-react";
import { TABS, type TabId } from "../data";

const ICONS: Record<TabId, React.ComponentType<{ className?: string }>> = {
  overview: LayoutDashboard,
  files: FolderOpen,
  packs: Package,
  daw: AudioWaveform,
  payments: ReceiptText,
  settings: Settings,
};

interface SidebarProps {
  activeTab: string;
  isAdminWorkspace: boolean;
  setActiveTab: (tab: TabId) => void;
}

export default function Sidebar({ activeTab, isAdminWorkspace, setActiveTab }: SidebarProps) {
  return (
    <aside className="sidebar">
      {TABS.filter((t) => isAdminWorkspace || !t.adminOnly).map((tab) => {
        const Icon = ICONS[tab.id];
        return (
          <button
            key={tab.id}
            className={`tab-btn ${activeTab === tab.id ? "tab-active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
            type="button"
          >
            <Icon className="h-4 w-4" />
            <span>{isAdminWorkspace && tab.adminLabel ? tab.adminLabel : tab.label}</span>
          </button>
        );
      })}
    </aside>
  );
}
